import { Row, Col, Checkbox, Input } from "antd";
import React from "react";
import { TTranslate } from "../../../../core/service/locale/TranslationService";
const CheckboxGroup = Checkbox.Group;

const defaultTextOptions = ["summary", "notes_txt", "attr_attachment_content"];

const SearchTermInput = ({
  value,
  onChange,
  translate
}: {
  value: string;
  translate: TTranslate;
  onChange: (
    allFields: string[],
    selectedFields: string[],
    value: string
  ) => any;
}) => {
  const textOptions = [
    { value: "summary", label: translate("search.advanced.summary") },
    { value: "notes_txt", label: translate("search.advanced.notes_txt") },
    {
      value: "attr_attachment_content",
      label: translate("search.advanced.attr_attachment_content")
    }
  ];

  const [text, setText] = React.useState(value);
  if (text !== value) {
    setText(value);
  }
  const [selectedTextOptions, setCheckedList] =
    React.useState(defaultTextOptions);

  const onSelectionChanged = (list) => {
    setCheckedList(list);
    onChange(defaultTextOptions, list, text);
  };
  return (
    <Row>
      <Col sm={24}>
        <Row>
          <Col sm={24} style={{ paddingBottom: 10 }}>
            <Input
              value={text}
              placeholder={translate("search.advanced.term_placeholder")}
              onChange={(event) => {
                setText(event.target.value);
                onChange(
                  defaultTextOptions,
                  selectedTextOptions,
                  event.target.value
                );
              }}
            ></Input>
          </Col>
        </Row>
        <Row>
          <Col sm={24}>
            <CheckboxGroup
              options={textOptions}
              value={selectedTextOptions}
              onChange={onSelectionChanged}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SearchTermInput;
